import React, { useEffect } from 'react';
import { Header, MenuItemOption } from '../../common_v2/components/Header';
import { Footer } from '../../common_v2/components/Footer';
import { ExperiencePanel } from './components/ExperiencePanel/ExperiencePanel';
import { useVerifiedExperienceQuery, useUnverifiedExperienceQuery } from './../queries/userExperienceQueries';
import { ExperienceHeader } from './components/ExperienceHeader/ExperienceHeader';
import { useWaitOverlayStore } from '@apply/components';

export default function ExperiencePageV2() {
    const { data: verifiedExperience = [], isFetching: isFetchingVerified } = useVerifiedExperienceQuery();
    const { data: unverifiedExperience = [], isFetching: isFetchingUnverified } = useUnverifiedExperienceQuery();
    const { setWaiting } = useWaitOverlayStore();

    useEffect(() => {
        setWaiting(false);
        const isLoading = isFetchingVerified || isFetchingUnverified;

        if (isLoading) {
            setWaiting(true, 'Loading experience data...');
        } else {
            setWaiting(false);
        }
    }, [isFetchingVerified, isFetchingUnverified, setWaiting]);

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.Experience} />
                <main>
                    <div className='experience'>
                        <ExperienceHeader verifiedExperience={verifiedExperience} />
                        <div className='experience-sectionTabPanel'>
                            <ExperiencePanel
                                verifiedExperience={verifiedExperience}
                                unverifiedExperience={unverifiedExperience}
                            />
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
}
